import React, {Fragment, useState, useEffect} from 'react'
import {Form, Icon} from 'semantic-ui-react'
import {default as EventPicker} from '../../eventpicker/picker'
import { useFirestore } from 'react-redux-firebase';
import {env} from '../../../constants/Environment';

const moment = require('moment');

export const Eventcard = (props) => {
    const [content, setContent] = useState('');
    const [isEditable, setIsEditable] = useState(true);
    const [event, setEvent] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const firestore = useFirestore();

    useEffect(() => {
        if(event !== null){
            let uid = event.uid;
            let marketUid = event.markets[0].uid;

            props.onChange({
                uid: uid,
                market: marketUid
            });
        }
    }, [event]);

    useEffect(() => {
        if(typeof props.payload !== 'undefined' && props.payload !== null){
            if(event === null || event.uid !== props.payload.uid || event.markets[0].uid !== props.payload.market){
                setIsLoading(true);

                (async () => {
                    let doc = await firestore.collection('environments/' + env + '/programs/0/oe').doc(props.payload.uid).get();
                    if(doc.exists){
                        let eventData = doc.data();
                        setIsLoading(false);

                        setEvent({
                            ...eventData,
                            markets: [
                                eventData.markets.find((m) => m.uid === props.payload.market)
                            ]
                        });
                    }
                })();
            }
        }
    }, [props.payload]);

    return (
        <div style={{
            boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.2)',
            borderRadius: '3px',
            maxWidth: '500px',
            padding: '15px',
            position: 'relative',
            overflow: 'hidden'
            //backgroundColor: 'rgba(0, 0, 0, 0.05)'
        }}>
            {
                (event === null)?null
                :
                <div style={{
                    /*filter: 'blur(0.25rem)',
                    position: 'absolute',*/
                    display: (event === null)?'none':'block'
                    //opacity: 0.5
                }}>
                    <div style={{
                        borderBottom: '1px solid #CCCCCC',
                        padding: '15px 5px 15px 5px',
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            display: 'inline-block',
                            backgroundColor: '#0000FF',
                            width: '16px',
                            height: '16px',
                            borderRadius: '8px',
                            marginRight: '5px'
                        }}></div>
                        {
                            (event === null)?
                                "Integer, Tincidunt Cras dapibus - Vivamus"
                            :
                                (event.sport.name + ' - ' + event.tournament.name)
                        }</div>
                    <div style={{
                        padding: '15px 5px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                border: '2px solid #CCCCCC',
                                borderRadius: '20px',
                                lineHeight: '36px',
                                verticalAlign: 'middle',
                                textAlign: 'center',
                                fontSize: '0.8em',
                                fontWeight: 'bold',
                                flexGrow: 0,
                                marginRight: '15px'
                            }}>
                                {
                                    (event === null)?
                                        "--:--"
                                    :
                                        moment.unix(event['active-to-utc'].seconds).format('HH:mm')
                                }
                            </div>
                            <div style={{
                                flexGrow: 1
                            }}>
                                {
                                    (typeof event['teams'] === 'undefined' || event['teams'] === null)?
                                        event.name
                                    :
                                        <Fragment>
                                            <div>{event.teams[0].name}</div>
                                            <div>{event.teams[1].name}</div>
                                        </Fragment>
                                }
                            </div>
                            <div style={{
                                flexGrow: 0,
                                color: '#00a75d',
                                marginLeft: '15px',
                                whiteSpace: 'nowrap'
                            }}>
                                {event['market-count'].active} ›
                            </div>
                        </div>
                        {
                            Object.values(event.markets).map((market) => {
                                return (
                                     <div style={{
                                        display: 'grid',
                                        gridGap: '10px',
                                        'grid-template-columns': 'repeat(auto-fit, minmax(30%, 1fr))',
                                        marginTop: '30px'
                                    }}>
                                        {
                                            market.selection.map((selection) => {
                                                return (
                                                    <div style={{
                                                        textAlign: 'center',
                                                        backgroundColor: '#EEEEEE',
                                                        borderBottom: '1px solid #000000',
                                                        fontWeight: 'bold',
                                                        padding: '5px'
                                                    }}>
                                                        <div style={{
                                                            color: '#666666',
                                                            fontSize: '0.9em'
                                                        }}>{(typeof selection['alternative-names'] !== 'undefined' && typeof selection['alternative-names'] !== null && typeof selection['alternative-names'].readable !== 'undefined')?selection['alternative-names'].readable[0]:selection.name}</div>
                                                        <div style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '1.1em'
                                                        }}>{selection.odd}</div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            }
            {
                (event === null && !isLoading)?
                    <div>
                        <EventPicker onSelectEvent={(e) => {
                        }} pickMarkets={true} onSelectMarket={(event, market) => {
                            setEvent({
                                ...event,
                                markets: [
                                    event.markets.find((m) => m.uid === market.uid)
                                ]
                            });
                        }} />
                    </div>
                :
                        props.readonly?
                            null
                        :
                            <a style={{
                                display: 'block',
                                marginTop: '1em',
                                paddingTop: '1em',
                                borderTop: '1px solid #DDDDDD',
                                color: '#777777',
                                cursor: 'pointer',
                                textAlign: 'right'
                            }} onClick={(e) => setEvent(null)}>
                                <Icon circular name="pencil" /> Anderes Event auswählen ›
                            </a>
            }
        </div>
    )
}